"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateToV4 = void 0;
var lodash_1 = require("lodash");
var versions_1 = require("@wix/wix-vod-constants/dist/app-settings/versions");
/* Don't change settings here! To change settings behavior, create new version */
function migrateToV4(appSettingsV3) {
    var _a = appSettingsV3.colors, colors = _a === void 0 ? {} : _a;
    var buttonsAndLinksColor = colors.buttonsAndLinksColor, mainButtonColor = colors.mainButtonColor;
    return (0, lodash_1.merge)({}, appSettingsV3, {
        numbers: {
            settingsVersion: versions_1.APP_SETTINGS_VERSION_4,
        },
        colors: {
            mainButtonColor: mainButtonColor || buttonsAndLinksColor,
        },
    });
}
exports.migrateToV4 = migrateToV4;
//# sourceMappingURL=version-4.js.map